<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="tab.waveIssue" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh"/>
        <vxe-button content="button.waveStatus" icon="vxe-icon-information" mode="text" status="primary" @click="handleWaveStatus"/>
      </template>
      <vxe-table
        ref="waveTable"
        :column-config="{resizable: true}"
        :data="waves"
        :export-config="{}"
        :height="waveScrollY"
        :keyboard-config="{isArrow: true}"
        :loading="loadingWave"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        keep-source
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe
        @cell-click="({row})=>waveClick(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="dispatch.wave" title="business.label.wave" width="100"/>
        <vxe-column field="ordersCount" title="business.label.ordersCount" width="60"/>
        <vxe-column field="statistics.numberOfItem" title="business.label.numberOfItem" width="60"/>
        <vxe-column field="statistics.numberOfFcl" title="business.label.numberOfFcl" width="60"/>
        <vxe-column field="statistics.numberOfLcl" title="business.label.numberOfLcl" width="60"/>
        <vxe-column field="statistics.numberOfEach" title="business.label.numberOfEach" width="60"/>
        <vxe-column field="statistics.numberOfRefrigeration" title="business.label.numberOfRefrigeration" width="60"/>
        <vxe-column field="statistics.numberOfValuable" title="business.label.numberOfValuable" width="60"/>
        <vxe-column field="statistics.numberOfImportation" title="business.label.numberOfImportation" width="60"/>
        <vxe-column field="statistics.numberOfPsychotropic" title="business.label.numberOfPsychotropic" width="60"/>
        <vxe-column field="statistics.numberOfSpecial" title="business.label.numberOfSpecial" width="60"/>
        <vxe-column field="statistics.numberOfPeptides" title="business.label.numberOfPeptides" width="60"/>
        <vxe-column field="statistics.numberOfGift" title="business.label.numberOfGift" width="60"/>
        <vxe-column field="statistics.numberOfOthers" title="business.label.numberOfOthers" width="60"/>
        <vxe-column field="statistics.numberOfSupervised" title="business.label.numberOfSupervised" width="60"/>
        <vxe-column field="statistics.standardCaseQuantity" title="business.label.standardCaseQuantity" width="100"/>
        <vxe-column field="statistics.volume" title="business.label.volume" width="100"/>
        <vxe-column field="statistics.weight" title="business.label.weight" width="100"/>
        <vxe-column field="statistics.amount" title="business.label.amount" width="100"/>
        <vxe-column field="waveLog.notes" title="business.label.notes" width="200"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.waveReplenish" icon="vxe-icon-goods-fill" status="primary" @click.stop="replenish(row)"/>
            <vxe-button content="button.issue" icon="vxe-icon-send" status="primary" @click.stop="issue(row)"/>
            <vxe-button content="button.cancel" icon="vxe-icon-undo" status="danger" @click.stop="cancel(row)"/>
            <vxe-button content="business.label.notes" icon="vxe-icon-information" status="primary" @click.stop="openNoteModal(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <vxe-table
        ref="orderTable"
        :column-config="{resizable: true}"
        :data="orders"
        :export-config="{}"
        :height="orderScrollY"
        :keyboard-config="{isArrow: true}"
        :loading="loadingOrder"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="pickupMode.name" title="business.label.shipmentMode" width="80"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column field="statistics.numberOfItem" title="business.label.numberOfItem" width="60"/>
        <vxe-column field="statistics.numberOfFcl" title="business.label.numberOfFcl" width="60"/>
        <vxe-column field="statistics.numberOfLcl" title="business.label.numberOfLcl" width="60"/>
        <vxe-column field="statistics.numberOfEach" title="business.label.numberOfEach" width="60"/>
        <vxe-column field="statistics.numberOfRefrigeration" title="business.label.numberOfRefrigeration" width="60"/>
        <vxe-column field="statistics.numberOfValuable" title="business.label.numberOfValuable" width="60"/>
        <vxe-column field="statistics.numberOfImportation" title="business.label.numberOfImportation" width="60"/>
        <vxe-column field="statistics.numberOfPsychotropic" title="business.label.numberOfPsychotropic" width="60"/>
        <vxe-column field="statistics.numberOfSpecial" title="business.label.numberOfSpecial" width="60"/>
        <vxe-column field="statistics.numberOfPeptides" title="business.label.numberOfPeptides" width="60"/>
        <vxe-column field="statistics.numberOfGift" title="business.label.numberOfGift" width="60"/>
        <vxe-column field="statistics.numberOfOthers" title="business.label.numberOfOthers" width="60"/>
        <vxe-column field="statistics.numberOfSupervised" title="business.label.numberOfSupervised" width="60"/>
        <vxe-column field="statistics.standardCaseQuantity" title="business.label.standardCaseQuantity" width="100"/>
        <vxe-column field="statistics.volume" title="business.label.volume" width="100"/>
        <vxe-column field="statistics.weight" title="business.label.weight" width="100"/>
        <vxe-column field="statistics.amount" title="business.label.amount" width="100"/>
        <vxe-column field="order.notes" title="business.label.notes" width="200"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.removeOrder" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <wave-status-modal ref="waveStatusModal"/>
    <text-area-modal ref="noteModal" :max-rows="30" :min-rows="20" :title="$t('business.label.notes')" @change="onNoteChange"/>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '@/api'
import moment from 'moment'
import { findAll, post, save } from '@/api/Api'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import WaveStatusModal from '@/views/outbound/dispatch_order/WaveStatusModal.vue'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'

export default {
  name: 'Release',
  components: { TextAreaModal, WaveStatusModal },
  data() {
    return {
      waves: [],
      orders: [],
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      loadingWave: false,
      loadingOrder: false,
      waveScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.2375),
      orderScrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.6)
    }
  },
  methods: {
    moment,
    back() {
      this.$emit('back')
    },
    openNoteModal(row) {
      this.$refs.noteModal.open(row.waveLog.notes, row)
    },
    onNoteChange(value, row) {
      this.loadingWave = true
      row['waveLog'].notes = value
      const args = Object.assign({}, row['waveLog'])
      args.wave = row.dispatch.wave
      save('waveLogPersister', args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
        }
      }).finally(() => this.loadingWave = false)
    },
    refresh() {
      this.loadingWave = true
      this.orders = []
      findAll('dispatchWaveSummaryFactory').then(res => {
        if (res.success) {
          this.waves = res.result
          if (this.waves.length > 0) {
            const current = this.waves[0]
            this.$refs.waveTable.setRadioRow(current)
            this.$refs.waveTable.setCurrentRow(current)
            this.waveClick(current)
          }
        }
      }).finally(() => this.loadingWave = false)
    },
    getOrderData(wave) {
      this.loadingOrder = true
      const param = {
        'orderStatusRange': { 'start': 'ARRANGED', 'end': 'ARRANGED' },
        'wave': wave
      }
      findAll('dispatchOrderListFactory', param).then(res => {
        if (res.success) {
          this.orders = res.result
        }
      }).finally(() => this.loadingOrder = false)
    },
    waveClick(record) {
      this.getOrderData(record.dispatch.wave)
    },
    replenish(row) {
      post(api.replenishingReplenish, { type: 'waveReplenisher' }, { wave: row.dispatch.wave }).then(res => {
        if (res.success) {
          this.refresh()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      })
    },
    issue(row) {
      post(api.dispatchIssue, {}, { wave: row.dispatch.wave }).then(res => {
        if (res.success) {
          this.refresh()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      })
    },
    cancel(row) {
      post(api.dispatchCancel, {}, { wave: row.dispatch.wave }).then(res => {
        if (res.success) {
          this.refresh()
          this.$message.success(this.$t('message.operationSuccess'))
        }
      })
    },
    remove(row) {
      post(api.dispatchRemove, {}, { id: row.order.id }).then(res => {
        if (res.success) {
          this.getOrderData(this.$refs.waveTable.getCurrentRecord().dispatch.wave)
          this.$message.success(this.$t('message.operationSuccess'))
        }
      })
    },
    handleWaveStatus() {
      this.$refs.waveStatusModal.open()
    }
  }
}
</script>